import React, { FC } from 'react'
import { Box } from '@mui/material'
import { DensityStyleTypes } from 'types'
import { GridRenderCellParams } from '@mui/x-data-grid-premium'
import { userAvatarGroup } from 'components/DataGrid/operators/minimalistFunctions'

interface NextRoleCellProps {
  params: GridRenderCellParams
  densityStyles: DensityStyleTypes
}
const NextRoleCell: FC<NextRoleCellProps> = React.memo(({ params, densityStyles }) => {
  const nextRole = params?.row?.nextRole === 'MIA' ? 'Integration' : params?.row?.nextRole ?? null
  const currentTeam = nextRole ? params?.row?.onboardingTeam?.filter(t => t?.role === nextRole) ?? [] : []
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        padding: densityStyles.padding,
      }}
    >
      {/* {nextRole ?? null} */}
      {userAvatarGroup(currentTeam, densityStyles)}
    </Box>
  )
})

NextRoleCell.displayName = 'NextRoleCell'

export default NextRoleCell
